import { reactive, watch } from "vue";
import { useRoute } from "vue-router";

type Schema<T> = {
  parse: (data: unknown) => T;
};

export function useQueryParams<T extends object>(
  schema: Schema<T>,
  route = useRoute(),
) {
  const queryParams = reactive(schema.parse(route.query));

  watch(
    () => route.query,
    (query) => Object.assign(queryParams, schema.parse(query)),
  );

  return queryParams;
}
